module.exports = __webpack_public_path__ + "static/img/sjgj.6286d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjgj.png
// module id = lWJs
// module chunks = 0